export const iconFontAwesomeFoodBeverageFlask = (
	<i className="fa-solid fa-flask"></i>
);
